import {SpanIcon} from '@mazraeapp/react_icon_kit';
import {Dispatch, SetStateAction} from 'react';
import {useNavigate} from 'react-router-dom';
import {BottomSheet} from 'react-spring-bottom-sheet';
import Button from '../../../../../../components/button';

type ISuccessProps = {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
};

const SuccessTerminationRequestSendBottomSheet = ({
  open,
  setOpen,
}: ISuccessProps) => {
  const navigate = useNavigate();

  const handleClose = () => {
    setOpen(false);
    navigate('/my-store-info');
  };

  return (
    <BottomSheet
      open={open}
      onDismiss={handleClose}
      blocking
      className="custom-bottom-sheet"
    >
      <div className="relative flex flex-col gap-[1rem] p-[1.5rem]">
        <SpanIcon
          className="absolute text-3xl text-gray-600 cursor-pointer top-5 left-5 icon-nameClose-remove"
          onClick={handleClose}
        />

        <div className="flex flex-col items-center justify-center gap-[1rem]">
          <div className="flex flex-col items-center justify-center">
            <i className="mb-2 text-4xl text-farm-shop-500 icon-nameCheck-circle" />
            <h4 className="mb-0 text-lg font-medium text-center text-gray-900">
              درخواست فسخ قرارد
            </h4>
          </div>
          <p className="mb-0 font-normal text-gray-600 text-md">
            درخواست فسخ قرارداد شما ثبت شد و بعد از بررسی توسط کارشناسان نتیجه
            به شما اعلام می‌شود.
          </p>
        </div>

        <Button
          className="flex items-center justify-center w-full text-white rounded-lg bg-farm-shop-500"
          onClick={handleClose}
        >
          متوجه شدم
        </Button>
      </div>
    </BottomSheet>
  );
};

export default SuccessTerminationRequestSendBottomSheet;
